import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { Blocks } from './index';
import { Button } from '../ui/button';
export default function Rotator(props) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [mounted, setMounted] = useState(false);
  const maxHeightRef = useRef(null);
  useEffect(() => {
    setMounted(true);
    const timer = setTimeout(() => {
      setActiveSlide((prev) => (prev + 1) % props.items.length);
    }, 5000);
    return () => clearTimeout(timer);
  }, [activeSlide]);

  useLayoutEffect(() => {
    if (maxHeightRef.current) {
      const children = maxHeightRef.current.children;
      let maxHeight = 0;
      for (let i = 0; i < children.length; i++) {
        if (children[i].scrollHeight > maxHeight) {
          maxHeight = children[i].scrollHeight;
        }
      }
      maxHeightRef.current.style.height = `${maxHeight}px`;
    }
  }, [mounted, props.items, activeSlide]);
  return (
    <div
      className="max-width"
      style={{
        backgroundColor: props.bgColor,
        color: props.textColor,
        padding: props.padding,
      }}
    >
      <div className="flex gap-2 mb-4 justify-center flex-wrap">
        {props.items?.map((slide, i) => (
          <Button
            variant={activeSlide === i ? 'default' : 'ghost'}
            key={i}
            size="sm"
            onClick={() => setActiveSlide(i)}
          >
            {slide.title}
          </Button>
        ))}
      </div>
      <div
        className="relative w-full"
        style={{ height: '50vh' }}
        ref={maxHeightRef}
      >
        {props.items?.map((slide, i) => {
          const isActive = activeSlide === i;
          const isPrevious = activeSlide > i;
          const isNext = activeSlide < i;
          const distance = Math.abs(activeSlide - i);
          const BASE_DISTANCE = 0;
          const realDistance = BASE_DISTANCE + distance * 8;
          const firstBlockBackgroundColor = slide.content?.reduce?.(
            (c, block) => {
              if (c) return c;
              const p = block[block.type];
              return p.bgColor;
            },
            false,
          );

          const transform = isActive
            ? 'translateX(0)'
            : isNext
            ? `translateX(${realDistance}%) scale(${1 - distance * 0.12})`
            : `translateX(${-realDistance}%) scale(${1 - distance * 0.12})`;
          return (
            <div
              key={i}
              className="absolute overflow-hidden shadow-2xl top-0 left-0 w-full min-h-full transition-all duration-500 rounded-lg"
              style={{
                backgroundColor: firstBlockBackgroundColor || props.bgColor,
                transform: transform,
                zIndex: 100 - distance,
                opacity: isActive ? 1 : 0.9,
                filter: `blur(${distance * 0.3}px)`,
              }}
            >
              {Array.isArray(slide.content) &&
                slide.content?.map?.((block, i) => {
                  const Block = Blocks[block.type];
                  return <Block key={i} {...block[block.type]} />;
                })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
